import { LOGO_URL } from "@/lib/brand";

const links = [
  ["What's inside", "/#whats-inside"],
  ["Our way", "/#philosophy"],
  ["Plans", "/#pricing"],
  ["Founders", "/#founders"],
  ["FAQ", "/#faq"],
];

export const Nav = () => (
  <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-stone-200/70" data-testid="site-nav">
    <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
      <a href="/" className="flex items-center gap-2" data-testid="nav-logo-link">
        <img src={LOGO_URL} alt="The Little Lantern Club" className="h-14 w-auto object-contain" />
      </a>
      <nav className="hidden md:flex items-center gap-9 text-sm text-stone-600">
        {links.map(([label, href]) => (
          <a key={href} href={href} className="hover:text-stone-900 transition-colors duration-200" data-testid={`nav-link-${href.slice(2)}`}>
            {label}
          </a>
        ))}
      </nav>
      <a
        href="/#pricing"
        className="rounded-full bg-stone-900 text-white text-sm px-5 py-2.5 hover:bg-amber-600 transition-colors duration-300"
        data-testid="nav-join-button"
      >
        Join the club
      </a>
    </div>
  </header>
);
